import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "./Icon.tsx";

/** Copies text to the clipboard; `compact` is an icon-only button for tables. */
export function CopyButton({ text, label, compact }: { text: string; label?: string; compact?: boolean }) {
  const { t } = useTranslation();
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      className={compact ? "btn btn-quiet btn-icon" : "btn btn-secondary btn-small"}
      aria-label={compact ? `${label ?? t("mapView.copy")}: ${text}` : undefined}
      title={compact ? (label ?? t("mapView.copy")) : undefined}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text);
          setDone(true);
          setTimeout(() => setDone(false), 2000);
        } catch {
          // Clipboard refused: the text stays selectable next to the button.
        }
      }}
    >
      <Icon name={done ? "check" : "copy"} />
      {!compact && (done ? t("mapView.copied") : (label ?? t("mapView.copy")))}
    </button>
  );
}
